module.exports = __webpack_public_path__ + "img/standort_pfarrei-st-martin_0.736feec0.png";